import React from 'react';
import RadioComponent from "../RadioComponent";
import Tooltip from "../Tooltip";
import Label from "../Label";

import typeFlexible from 'images/products/surface_mount_carriers/pressure-holder-flexible.png'
import typeStandard from 'images/products/surface_mount_carriers/pressure-holder-standard.png'

const PressureHolderType = (props) => {
  const {name, parameters} = props;
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const value = parameters[name];
  return (
    <div className="form-group">
      <Label label={props.label} required={props.required}>
        <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
      </Label>
      <div className="row">
        <div className="col-12">
          <RadioComponent
            {...props}
            checked={value === 'none'}
            inputId="pressure-holder-type-none"
            inputClassName={props.inputClassName}
            label="None"
            name={name}
            onChange={onChange}
            value="none" />
        </div>
        <div className="col-6">
          <RadioComponent
            {...props}
            checked={value === props.noValue}
            inputId="pressure-holder-type-a"
            inputClassName={props.inputClassName}
            label={props.noLabel}
            name={name}
            onChange={onChange}
            value={props.noValue} />
          <img src={typeStandard} className="img-fluid" />
        </div>
        <div className="col-6">
          <RadioComponent
            {...props}
            checked={value === props.yesValue}
            inputId="pressure-holder-type-b"
            inputClassName={props.inputClassName}
            label={props.yesLabel}
            name={name}
            onChange={onChange}
            value={props.yesValue} />
          <img src={typeFlexible} className="img-fluid" />
        </div>
      </div>
      {props.children}
    </div>
  );
}


PressureHolderType.defaultProps = {
  name: 'pressure_holder_type',
  label: 'What kind of pressure holders do you need?',
  noLabel: 'Standard ($1 each)',
  noValue: 'standard-holder',

  yesLabel: 'Flexible (No charge)',
  yesValue: 'flexible-holder',
};

export default PressureHolderType;
